angular.module("digitalLeasing.module").component("insuredSubject", {
    templateUrl: "ng/components/digitalLeasing/goodManagement/insuredSubject/insuredSubject.view.html",
    bindings: {
        model: "=", //elementToAdd
        preventivo: "=",
        subjectIsOk: "&",
        subjectIsNotOk: "&"
    },
    controllerAs: "insuredSubjectCtrl",
    controller: InsuredSubjectController
});

function InsuredSubjectController(validationService, RiUserF, Pf, $rootScope, $typeDomainService, $istatService) {
    var self = this;

    self.$onInit = function () {
        self.mapComuni = $rootScope.comuniMap;
        self.supportModel = {
            options: ["PERSONA"],
            defaultOptions: "PERSONA",
            initialsubject: "",
            endSearchRest: false,
            ageIsOk: true
        }

        if (self.model.soggettoAssicurato && self.model.soggettoAssicurato.cf) {
            self.supportModel.initialsubject = self.model.soggettoAssicurato;
        }
        getStati();
        checkValidation();
    };

    self.getSubject = function (value) {
        self.supportModel.endSearchRest = !self.supportModel.endSearchRest;
        if (value && self.validityCustomerDigital) {
            self.model.soggettoAssicurato = value.riUserF;
        }
        if (self.model.soggettoAssicurato && self.model.soggettoAssicurato.datiNascita && self.model.soggettoAssicurato.datiNascita.data) {
            verifySubject(self.model.soggettoAssicurato.datiNascita.data);
        }
        checkValidation();
    }

    self.exportValidityCustomerDigital = function (validity) {
        self.validityCustomerDigital = validity;
        checkValidation();
    }

    var verifySubject = function (bDaySubject) {
        var dataDiNascita = "";
        if (!bDaySubject) {
            var riUserF = RiUserF.build();
            riUserF.addPf(Pf.build(self.model.soggettoAssicurato).setDefaultPfValues(self.nationsList, self.mapComuni));
            self.model.soggettoAssicurato.datiNascita = riUserF.listaPf[0].datiNascita;
            dataDiNascita = self.model.soggettoAssicurato.datiNascita.data;
        } else {
            dataDiNascita = bDaySubject;
        }
        var newAge = validationService.calcAge(dataDiNascita);

        var testAge = true;
        self.preventivo.assicurazioni.forEach(function (element) {
            //se l'età testata precedentemente torna false, non testo quelle successive
            if (testAge) {
                testAge = checkAge(element.polizze, newAge);
                self.supportModel.ageIsOk = testAge;
            }
        });
    }

    var checkAge = function (polizze, newAge) {
        return (polizze && polizze.every(function (el) {
            return el.etaSoggettoAnagrafico > newAge
        }))
    }

    var checkValidation = function () {
        if (self.model.soggettoAssicurato &&
            self.validityCustomerDigital &&
            self.supportModel.ageIsOk
        ) {
            self.subjectIsOk();
        } else {
            self.subjectIsNotOk();
        }
    }

    var getStati = function () {
        $istatService.getNazioni()
            .then(function (response) {
                self.nationsList = response.domainList;

                self.nationsList = self.nationsList.filter(
                    function (elem) {
                        return elem.name != "ITALIA";
                    }
                );
            });

    };
}